import structuredClone from "@ungap/structured-clone";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { PUBLIC_CND_BASEURL } from "../App";
import { pageAnimation } from "../animation";
import ScrollTop from "../components/ScrollTop";
import { preislistData } from "../preislistData";

// The "Alle Bruttopreise ..." note must always be the last row of a price list.
const isVatNote = (item) => item.titel.trim().startsWith("Alle Bruttopreise");

const hasColumn = (items, key) =>
	items.some((item) => !isVatNote(item) && item[key]);

const getFullLength = (items) =>
	5 +
	(hasColumn(items, "personenanzahl") ? 1 : 0) +
	(hasColumn(items, "platz_and_tech") ? 1 : 0);

function Prices({ aPrice }) {
	const location = useLocation();
	const url = location.pathname;
	const [prices] = useState(preislistData);
	const [price, setPrice] = useState(null);
	const [fullLength, setFullLength] = useState(0);

	useEffect(() => {
		if (aPrice) {
			setFullLength(getFullLength(aPrice));
			setPrice(aPrice);
		} else {
			const currentPrice = prices.filter((price) => price.url === url);
			const myPrice = [];
			currentPrice[0].items.forEach((item) => {
				const obj = structuredClone(item);
				Object.keys(obj).forEach((key, index) => {
					obj[key] = obj[key].replace(/ {2,}/g, "\n");
				});
				myPrice.push(obj);
			});
			if (!currentPrice[0].doNotSort) {
				myPrice.sort((a, b) =>
					a.titel < b.titel ? -1 : a.titel > b.titel ? 1 : 0,
				);
			}
			setFullLength(getFullLength(myPrice));
			console.log("my: ", myPrice);
			setPrice(myPrice);
		}
	}, [prices, url, aPrice]);

	const showPersonen = price && hasColumn(price, "personenanzahl");
	const showPlatz = price && hasColumn(price, "platz_and_tech");

	return (
		<>
			<motion.div
				exit="exit"
				variants={pageAnimation}
				initial="hidden"
				animate="show"
			>
				<Style>
					{price && (
						<table width={"100%"} id={"table"}>
							<tr>
								<th>Artikel</th>
								<th>Bild</th>
								<th>Beschreibung</th>
								{showPersonen && <th>Personalanzahl</th>}
								{showPlatz && (
									<th>Platzbedarf & technische Daten</th>
								)}
								<th>Netto Betrag</th>
								<th>Brutto Betrag</th>
							</tr>
							{price.filter((item) => !isVatNote(item)).map((item) => {
								if (item.beschreibung !== "%footer%") {
									return (
										<tr key={item.titel}>
											<td>{item.titel}</td>
											<td width={"10%"} style={{ padding: 0 }}>
												<img
													height={"100%"}
													src={
														item.bild === ""
															? PUBLIC_CND_BASEURL +
																"/img/preisliste/detailed/" +
																item.titel +
																".jpg"
															: item.bild
													}
													alt=""
													width={"100%"}
													style={{ objectFit: "contain", minWidth: "150px" }}
												/>
											</td>
											<td width={"40%"}>{item.beschreibung}</td>
											{showPersonen && <td>{item.personenanzahl}</td>}
											{showPlatz && <td>{item.platz_and_tech}</td>}
											<td>{item.netto}</td>
											<td>{item.brutto}</td>
										</tr>
									);
								} else {
									return (
										<tr style={{ height: "50px" }} key={item.titel}>
											<td colspan={fullLength}>
												<strong>{item.titel}</strong>
											</td>
										</tr>
									);
								}
							})}
							<tr style={{ height: "50px" }}>
								<td colSpan={fullLength}>
									<strong>Die Preisliste ist ab 01.10.2022 gültig</strong>
								</td>
							</tr>
							{price.filter(isVatNote).map((item) => (
								<tr style={{ height: "50px" }} key={item.titel}>
									<td colSpan={fullLength}>
										<strong>{item.titel}</strong>
									</td>
								</tr>
							))}
						</table>
					)}
				</Style>
			</motion.div>
			<ScrollTop />
		</>
	);
}

const Style = styled(motion.div)`
    overflow-x: auto;
    width: 100%;

    #table {
        font-family: Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #table td, #table th, .footer {
        border: 1px solid #ddd;
        padding: 8px;
        white-space: pre-wrap;
        text-align: center;
    }

    #table tr:nth-child(even) {
        background-color: #d9e2f3;
    }

    #table th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: center;
        background-color: #d9e2f3;
        color: black;
    }
`;

export default Prices;
